var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormDepotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 589.79 237.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: #184437;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 38.12,
    x2: 239.52,
    y2: 38.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.13,
    y1: 67.03,
    x2: 231.4,
    y2: 67.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 20.21,
    y1: 95.93,
    x2: 223.21,
    y2: 95.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 30.27,
    y1: 124.83,
    x2: 215.02,
    y2: 124.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 40.34,
    y1: 153.73,
    x2: 206.84,
    y2: 153.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 50.49,
    y1: 182.64,
    x2: 198.73,
    y2: 182.64,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0 42.64 2.6 33.61 239.52 33.61 236.92 42.64 0 42.64"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.13 71.54 12.73 62.51 231.4 62.51 228.8 71.54 10.13 71.54"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "20.21 100.44 22.8 91.42 223.21 91.42 220.61 100.44 20.21 100.44"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "30.27 129.34 32.87 120.32 215.02 120.32 212.43 129.34 30.27 129.34"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "40.34 158.25 42.94 149.22 206.84 149.22 204.24 158.25 40.34 158.25"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.49 187.15 53.09 178.12 198.73 178.12 196.13 187.15 50.49 187.15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m221.04,221.22H75.13L136.21,0h145.91l-61.07,221.22h0Zm-136.22-7.37h130.61L272.43,7.37h-130.61l-57,206.47h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m207.18,187.15l43.45-153.54h72.99l-10.26,36.25h-32.67l-6.28,22.2h28.86l-10.26,36.25h-28.86l-16.66,58.85h-40.31Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m370.62,31.79c28.08,0,30.92,28.79,23.64,54.51-7.28,25.72-26.41,54.51-54.49,54.51s-30.92-28.79-23.64-54.51c7.28-25.72,26.41-54.51,54.5-54.51Zm-23.34,82.46c10.45,0,16.9-21.38,18.76-27.95,1.86-6.57,7.51-27.95-2.94-27.95s-16.9,21.38-18.76,27.95c-1.86,6.57-7.5,27.95,2.94,27.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.57,139l-2.91-43.89-.35.28c-1.33,5.17-2.52,10.34-3.98,15.51l-7.95,28.09h-27.67l29.83-105.39h26.72c24.01,0,39.32,7.27,31.44,35.08-3.28,11.6-11.09,21.94-23.35,26.42l8.2,43.89h-29.98Zm2.59-56.61c7.33,0,13.12-6.57,15.06-13.42,2.61-9.22-1.71-13.14-9.43-12.72l-7.35,26,1.72.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.11,139l16.17-66.25h-.27c-3.4,7.69-6.52,15.37-10.05,23.06l-20.09,43.19h-22.52l9.12-66.25h-.27c-2.35,7.83-4.39,15.51-7.01,23.34l-14.45,42.91h-29.71l41.76-105.39h34.46l-8,56.05h.28c2.67-6.57,5.17-13,8.25-19.57l16.97-36.48h34.05l-19.92,105.39h-28.76Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m273.44,148.16h17.55c24.84,0,33.66,17.03,26.54,43.62-10.86,40.59-35.3,44.32-48.58,44.32h-19.05l23.54-87.94Zm3.98,66.72c9.99-.12,15.32-13.65,17.53-21.93,2.56-9.56,4.41-22.86-5.55-22.86l-11.99,44.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m340.24,148.16h40.57l-5.56,20.76h-18.73l-3.28,12.24h16.8l-5.56,20.76h-16.8l-3.59,13.41h18.73l-5.56,20.76h-40.57l23.53-87.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m369.46,236.11l23.54-87.94h19.91c19.05,0,31.91,6.76,25.73,29.86-6.12,22.86-20.84,29.86-39.63,29.28l-7.71,28.81h-21.84Zm41.92-69.05l-1.64.12-5.43,20.29c5.9.35,10.62-3.27,12.36-9.8,1.5-5.6.06-10.62-5.29-10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m484.98,146.65c22.16,0,24.4,24.03,18.65,45.49-5.74,21.46-20.84,45.49-43,45.49s-24.4-24.03-18.65-45.49c5.74-21.46,20.84-45.49,43-45.49Zm-18.42,68.81c8.24,0,13.34-17.84,14.81-23.32,1.47-5.49,5.92-23.33-2.32-23.33s-13.34,17.84-14.8,23.33c-1.47,5.48-5.92,23.32,2.32,23.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m509.6,236.11l17.79-66.48h-13.83l5.74-21.46h50.04l-5.75,21.46h-14.37l-17.79,66.48h-21.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDepotLogo);
export default __webpack_public_path__ + "static/media/Form-depot-logo.237cb152c77eeff35a1f2783ec6969df.svg";
export { ForwardRef as ReactComponent };